<template>
    <div class="show-condition">
        <!-- 通过skip控制题目显示，通过show/showJson、matrix.value来控制值 -->
        <car-headerbar :title="title" :isCustomLeft="isCustomLeft"/>
        <div class="content-wrap">
            <span class="tip">设置显示条件</span>
            <ul class="conditions">
                <li v-for="(item, index) in newIndexTopicsList" :key="index" class="condition">
                    <template v-if="!item.skip">
                        <me-cell center :class="[item.show === '1' ? 'topic-title' : 'topic-title-radius']">
                            <template #title>
                                <span class="custom-title">
                                    {{item.index}}.<span class="topic-type">{{types[item.topicType]}}</span>{{item.topicName}}
                                </span>
                            </template>
                            <template #right-icon>
                                <me-switch
                                    v-model="item.show"
                                    active-value="1"
                                    inactive-value=""
                                    active-color="#06B455"
                                    inactive-color="#DBDBDB"
                                    size="24"/>
                            </template>
                        </me-cell>
                        <div class="show-wrap" v-if="item.show === '1' && item.topicType !== 'matrix-rate'">
                            <me-checkbox-group v-model="item.showJsonValue">
                                <me-cell-group>
                                    <span
                                        v-for="(option, i) in item.selectItem"
                                        :key="i">
                                        <me-cell
                                            :title="option.itemKey"
                                            clickable>
                                            <template #right-icon>
                                                <me-checkbox
                                                    :ref="item.topicId"
                                                    :name="item.topicType === 'rate' ? option.itemKey : i+''">
                                                    <template #icon="props">
                                                        <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                                                    </template>
                                                </me-checkbox>
                                            </template>
                                        </me-cell>
                                    </span>
                                </me-cell-group>
                            </me-checkbox-group>
                        </div>
                        <div class="show-wrap" v-if="item.show === '1' && item.topicType === 'matrix-rate'">
                            <div v-for="(matrix, matrixIndex) in item.matrixs" :key="matrixIndex" class="matrix-wrap">
                                <div class="matrix-title">
                                    <span class="topic-type">{{matrix.type}}</span>
                                    <span class="line-title">{{matrix.title}}:</span>
                                </div>
                                <me-checkbox-group v-model="matrix.value">
                                    <me-cell-group>
                                        <span
                                            v-for="(option) in matrix.count"
                                            :key="option">
                                            <me-cell
                                                :title="option"
                                                clickable>
                                                <template #right-icon>
                                                    <me-checkbox
                                                        ref="matrixs"
                                                        :name="option">
                                                        <template #icon="props">
                                                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                                                        </template>
                                                    </me-checkbox>
                                                </template>
                                            </me-cell>
                                        </span>
                                    </me-cell-group>
                                </me-checkbox-group>
                            </div>
                        </div>
                    </template>
                </li>
            </ul>
        </div>
        <confirm @confirm="confirm"/>
    </div>
</template>
<script>
import { Questionnaire } from '@/network'
import { addClass2, removeClass2 } from '@/util/status-util'
import { getStorage } from '@/util/common'
import { Toast } from '@guazi-fe/melon'
import { mixin } from '@/mixins'
import confirm from '../compontents/confirm.vue'
import activeIcon from '../images/checkbox-icon.png'
import inactiveIcon from '../images/uncheckbox-icon.png'
import browser from '@/util/browser'

export default {
    name: 'show-condition',
    components: { confirm },
    data() {
        return {
            topicData: {},
            topics: [],
            newIndexTopicsList: [],
            topic: {},
            title: '显示设置',
            types: {
                'radio': '【单选题】',
                'checkbox': '【多选题】',
                'rate': '【评分题】',
                'nps': '【NPS题】',
                'matrix-rate': '【矩阵评分题】',
            },
            activeIcon: activeIcon,
            inactiveIcon: inactiveIcon,
            isCustomLeft: false,
        }
    },
    computed: {
        pageId() {
            return this.$route.params.pageId
        },
        topicId() {
            return this.$route.params.topicId
        },
        type() {
            return this.$route.params.type
        },
    },
    created() {
        const { guaguaApp } = browser
        this.isCustomLeft = guaguaApp
        this.getTopics()
    },
    mixins: [mixin],
    methods: {
        toggle(item, i) {
            this.$refs[item.topicId].toggle()
        },
        getTopics() {
            const topics = getStorage('vuex') && getStorage('vuex').showTopicList || []
            const newIndexTopicsList = this.$store.state.showTopicList || topics
            this.topics = newIndexTopicsList
            if (topics && topics.length) {
                this.dealTopicIndex()
                removeClass2('body', 'loading')
                return
            }
            const data = {
                tid: this.tid,
                pageId: this.pageId,
            }
            addClass2('body', 'loading')
            Questionnaire.getQuestionDetail(data).then((res) => {
                removeClass2('body', 'loading')
                const { data, data: { topicsList } } = res.data
                this.topicData = data
                this.topic = topicsList.find(item => item.topicCode === this.topicId)
                this.topics = topicsList
                this.dealTopicIndex()
            }).catch((error) => {
                removeClass2('body', 'loading')
                console.log(error.response)
                Toast.fail(error.response.data.message)
            })
        },
        dealTopicIndex() {
            let time = 0
            let i = this.topics.findIndex(item => item.topicCode === this.topicId)
            i = i === -1 ? this.topics.length : i
            const topics = JSON.parse(JSON.stringify(this.topics))
            this.newIndexTopicsList = topics.map((item, index) => {
                // 处理题号
                let newIndex = 0
                if (/^paragraph$/.test(item.topicType)) {
                    time += 1
                }
                newIndex = index - time
                // 条件中不显示填空和段落
                this.topic && index >= i || /^paragraph|text|textarea$/.test(item.topicType) ? item.skip = true : null
                // 处理矩阵评分
                if (item.topicType === 'matrix-rate') {
                    const matrixs = item.matrixs
                    item.matrixs = []
                    item.selectItem.forEach((line, matrixIndex) => {
                        item.matrixs.push({
                            type: '【行标题】',
                            title: line.itemKey,
                            count: item.score / 1,
                            value: matrixs && matrixs[matrixIndex] ? matrixs[matrixIndex].value : [],
                        })
                    })
                }
                item.topicType !== 'matrix-rate' ? item.showJsonValue = item.showJsonValue || [] : null
                return { ...item, index: newIndex + 1 }
            })
        },
        confirm() {
            this.newIndexTopicsList.forEach((item) => {
                if (item.topicType === 'matrix-rate') {
                    item.matrixs && item.matrixs.length && item.matrixs.forEach((matrix) => {
                        matrix.value && matrix.value.length ? matrix.value.sort((a, b) => a - b) : null
                    })
                    return
                }
                item.showJsonValue.sort((a, b) => a - b)
            })
            this.$store.commit("updateShowTopicList", this.newIndexTopicsList)
            this.$router.back({
                name: 'show',
                params: {
                    pageId: this.pageId,
                    topicId: this.topicId,
                    type: this.type,
                },
            })
            // console.log('showJson', showJson)
        },
    },
}
</script>
<style scoped lang="scss">
    .content-wrap{
        padding: .32rem;
        border-bottom: 1.75rem solid #f7f7f7;
        font-size: .37rem;
    }
    .tip{
        font-size: .34rem;
        color: #9298A8;
    }
    .conditions{
        margin-top: .32rem;
        .condition{
            margin-bottom: .32rem;
        }
        .topic-type{
            color: #9298A8;
            font-size: .37rem;
        }
    }
    .custom-title{
        word-break: break-all;
    }
    ::v-deep .me-cell, ::v-deep .me-cell-group{
        background-color: #FBFBFC;
    }
    ::v-deep .me-cell::after{
        border: none;
    }
    ::v-deep .me-switch{
        margin-left: .42rem;
    }
    ::v-deep [class*=me-hairline]::after{
        border: none;
    }
    .topic-title, .topic-title-radius{
        padding: .42rem;
        color: #222;
        border-radius: .16rem .16rem 0 0;
        background: #fff;
        font-size: .37rem;
    }
    .topic-title-radius{
        border-radius: .16rem;
    }
    .show-wrap{
        border-radius:  0 0 .16rem .16rem;
        overflow: hidden;
    }
    ::v-deep .show-wrap .me-cell{
        align-items: flex-start;
        margin-left: 0.5rem;
        padding: 0.42667rem;
        width: calc(100% - .5rem);
        border-bottom: 1PX solid #F2F4F6;
    }
    ::v-deep .me-checkbox__icon{
        // height: .46rem;
    }
    .img-icon{
        margin-left: .32rem;
        width: .48rem;
        position: relative;
        top: .08rem;
    }
    .matrix-title{
        margin-left: .3rem;
        padding: 0.42667rem;
        background: #FBFBFC;
        border-bottom: 1PX solid #F2F4F6;
    }
    .matrix-wrap{
        background: #FBFBFC;
    }
    .line-title{
        color: #222;
        font-size: .37rem;
    }
</style>
